import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-work",
  "use": "icon-work-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-work\"><defs><style></style></defs><path d=\"M598 256v-86H426v86h172zm256 0c48 0 84 38 84 86v468c0 48-36 86-84 86H170c-48 0-84-38-84-86V342c0-48 36-86 84-86h172v-86c0-48 36-84 84-84h172c48 0 84 36 84 84v86h172z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol